module.exports = __webpack_public_path__ + "static/media/Spinner.afab26b3.svg";